<article>
  <div class="header">
    <h2>Top Consumer {{isFreemium ? 'Continents' : 'Countries' }}</h2>
    <h3>
      {{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}
    </h3>
    <mpro-tags style="margin: 15px 0px"></mpro-tags>
  </div>
  <div class="chart">
    <h4>Sorting</h4>
    <div class="buttons">
      <button
        color="blue"
        hue="500"
        mproButtton="secondary"
        *ngFor="let b of constants.data.sorting"
        [ngClass]="b.id === activeSorting ? 'active' : ''"
        (click)="handleSortingData(b.id)"
        [selected]="b.id === activeSorting"
      >
        {{ b.text }}
      </button>
    </div>
    <div id="legend">
      <ng-container *ngFor="let item of legendItems">
        <div>
          <span [style.backgroundColor]="item.color"></span>
          {{ item.text }}
        </div>
      </ng-container>
    </div>
    <p class="cagr-note"><span>%CAGR</span></p>
    <div style="width: 780px; height:500px; overflow-y: auto; overflow-x:hidden" id="horizontalBarChart"></div>
  </div>
</article>
